/* ------------------------------------------------------------------
  File: Home.jsx
  Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
  Last Modified: 2026-08-06
------------------------------------------------------------------ */

import HeroSection from '../../sections/Home/HeroSection';
// import AboutUsSection from '../../sections/Home/AboutUsSection';
// import OperatingSectorsSection from '../../sections/Home/OperatingSectorsSection';
// import GroupCompaniesSection from '../../sections/Home/GroupCompaniesSection';
// import InvestmentApproachSection from '../../sections/Home/InvestmentApproachSection';
// import NewsroomHighlightSection from '../../sections/Home/NewsroomHighlightSection';

function Home() {
  return (
    <div>
      <HeroSection />
      {/* <AboutUsSection /> */}
      {/* <OperatingSectorsSection /> */}
      {/* <GroupCompaniesSection /> */}
      {/* <InvestmentApproachSection /> */}
      {/* <NewsroomHighlightSection /> */}
    </div>
  )
}

export default Home